/* Krampus redesign — age gate wording and logo. Relabels the Omega age-verification
   overlay in place; Omega keeps its own verification, rejection handling and remember
   settings, and its YES/NO links (#av_submit_form / #av_cancel_form) are reused as-is.
   Loaded globally from layout/theme.liquid; independent of any section. */
(function () {
  var COPY = {
    eyebrow: 'A slightly sinister welcome',
    headline: 'Are you 21 or older?',
    text: 'Please confirm you’re 21 or older to enter.',
    yes: 'Yes, I’m 21+',
    no: 'No, I’m under 21',
    foot: 'Enjoy Krampus responsibly.'
  };
  var script = document.currentScript;
  var assetBase = script && script.src ? script.src.replace(/[^\/?#]+(\?.*)?$/, '') : '';
  var SVG = 'http://www.w3.org/2000/svg';
  function logo() {
    var img = document.createElement('img'); img.className = 'kh-ag-logo'; img.src = '/cdn/shop/files/kh-logo-collection-white.webp'; img.alt = 'Krampus Spirit Collection'; img.width = 900; img.height = 618; img.decoding = 'async'; return img;
  }
  function asButton(el, label) {
    el.textContent = label;
    el.setAttribute('role', 'button');
    if (!el.hasAttribute('href') && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    if (!el.dataset.khKeys) {
      el.dataset.khKeys = '1';
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
      });
    }
  }
  function restyle(form) {
    if (!form || form.dataset.khAg) return;
    var yes = form.querySelector('#av_submit_form');
    var no = form.querySelector('#av_cancel_form');
    var head = form.querySelector('.headline_text');
    // Only relabel the initial question state; anything else the app renders is left alone.
    if (!yes || !no || !head) return;
    form.dataset.khAg = '1';
    form.setAttribute('role', 'dialog');
    form.setAttribute('aria-modal', 'true');
    var logoWrap = form.querySelector('.logo-image');
    if (logoWrap) { logoWrap.innerHTML = ''; logoWrap.appendChild(logo()); }
    var eyebrow = document.createElement('p');
    eyebrow.className = 'kh-ag-eyebrow';
    eyebrow.textContent = COPY.eyebrow;
    head.parentNode.insertBefore(eyebrow, head);
    head.textContent = COPY.headline;
    head.id = head.id || 'kh-ag-title';
    form.setAttribute('aria-labelledby', head.id);
    var sub = form.querySelector('.subhead_text');
    if (sub) sub.textContent = COPY.text;
    asButton(yes, COPY.yes);
    asButton(no, COPY.no);
    var foot = document.createElement('p');
    foot.className = 'kh-ag-foot';
    foot.textContent = COPY.foot;
    form.appendChild(foot);
  }
  function check() { restyle(document.getElementById('av-overlay-form')); }
  check();
  new MutationObserver(check).observe(document.documentElement, { childList: true, subtree: true });
})();
